<template>
  <section>
    <div class="row">
      <div id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 50%;">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              Editing User &nbsp;
              <span>
                <button v-b-modal.modal-footer-sm class="btn btn-light px-0 py-1">
                  Change
                  Password
                  <i class="fa fa-edit"></i>
                </button>
              </span>
            </h4>
            <form class="form-sample" @submit="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input required type="text" v-model="name"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="User Name">
                    <b-form-input required type="text" v-model="username"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Phone">
                    <b-form-input required type="text" v-model="phone"></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group horizontal label="Email">
                    <b-form-input required type="email" v-model="email"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Organization">
                    <b-form-input type="text" v-model="organization"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Occupation">
                    <b-form-input type="text" v-model="occupation"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Gender">
                    <select id="type" class="form-control" name="Chooae Type" required placeholder="Choose Type"
                      v-model="gender">
                      <option value="female">Female</option>
                      <option value="male">Male</option>
                      <option value="others">Others</option>
                      <option value="notprefertosay">Not prefer to Say</option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="State">
                    <b-form-input type="text" v-model="State"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 form-group" style="font-size:16px!important">
                  <label for="exampleInputEmail1">Please upload Image</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file" ref="file"
                    v-on:change="handleFileUpload()" />
                  <p v-if="image">{{ data.photo }}</p>
                </div>
                <div class="col-md-2">
                  <div width="80px" height="80px" id="preview">
                    <img width="100%" height="100%" :src="image" />
                  </div>
                </div>
              </div>
              <hr />
              <label for="exampleInputEmail1" style="font-size:20px!important">Please Edit Location</label>

              <div class="input-group-prepend">
                <br />
                <div class="col-md-6">
                  <input name="lat" type="text" v-model="lat" class="form-control" placeholder="Please Enter Latitude"
                    required />
                </div>
                <br />
                <div class="col-md-6">
                  <input name="lon" type="text" v-model="lon" ref="myLngField" placeholder="Please Enter Longitude"
                    class="form-control" required />
                </div>
              </div>

              <br />

              <div id="myMap"></div>
              <br />
              <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
            </form>
            <b-modal id="modal-footer-sm" title button-size="sm">
              <form @submit="onsubmit1">
                <!-- <div class="pb-3">
                                    <label>Old Password</label>
                                    <input v-model="oldpassword" type="password" required class="pt-2 pb-2"
                                        style="color:black!important;width:100%!important;">
                                   
                </div>-->

                <div class="pb-3">
                  <label>Please Enter New Password</label>
                  <input v-model="password" type="password" required class="pt-2 pb-2"
                    style="color:black!important;width:100%!important;" />
                </div>
                <div class="pb-3">
                  <label>Confirm Password</label>
                  <input v-model="confPassword" type="password" required class="pt-2 pb-2"
                    style="color:black!important;width:100%!important;" />
                </div>
                <p class="py-1" style="color:red;font-size:12px">{{ msg_password }}</p>
                <div class="d-flex justify--center mt-3">
                  <button type="submit" class="pt-2 pb-2 btn btn-success" style="width:100%!important;">Submit</button>
                </div>
              </form>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  name: "edituser",
  props: ["id"],
  data: () => {
    return {
      username: "",
      name: "",
      password: "",
      confPassword: "",
      phone: "",
      email: "",
      organization: "",
      occupation: "",
      gender: "",
      state: "",
      image: null,
      file: "",
      lat: null,
      lon: null,
      msg_password: null,
      loading: false,
    };
  },
  mounted: function () {
    this.getDetails();
    this.getListClick();
    this.getList();
  },
  watch: {
    confPassword: function () {
      if (this.password != this.confPassword)
        this.msg_password = "Passwords not matching";
      else this.msg_password = null;
    },
  },
  watch: {
    lat: function () {
      this.getList();
      this.getListClick();
    },
    lon: function () {
      this.getList();
      this.getListClick();
    },
  },
  methods: {
    resetForm() {
      this.username = "";
      this.name = "";
      this.password = "";
      this.phone = "";
      this.email = "";
      this.occupation = "";
      this.organization = "";
      this.gender = "";
      this.state = "";
      this.error = "";
      this.file = null;
      this.image = null;
    },
    getDetails() {
      this.loading = true;
      var data1 = {};

      axios({
        method: "GET",
        url: "/user/info/",
        params: { id: this.id, token: localStorage.getItem("token") },
      })
        .then((response) => {
          this.loading = false;
          this.isstat = response.data.status;
          if (response.data.status === true) {
            this.data = response.data.data;
            this.username = response.data.data.username;
            this.name = response.data.data.name;
            this.password = response.data.data.password;
            this.phone = response.data.data.phone;
            this.email = response.data.data.email;
            this.occupation = response.data.data.occupation;
            this.organization = response.data.data.organization;
            this.lat = response.data.data.location[1];
            this.lon = response.data.data.location[0];
            if (response.data.data.photo != null) {
              this.image = imageURL + response.data.data.photo;
            }
            // var temp={}
            // for(var j=0;j<response.data.data.image.length;j++)
            // {
            //   var ty=response.data.data.image[j]
            //   temp.push(ty)
            // }
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          alert("Something went wrong");
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    getList() {
      var marker = 1;
      var vm = this;
      var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
      var options = {
        zoom: 4,
        center: centerOfMap,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
      };
      var map = new google.maps.Map(document.getElementById("myMap"), options);
      var latlngset = new google.maps.LatLng(this.lat, this.lon);

      marker = new google.maps.Marker({
        map: map,
        position: latlngset,
      });

      marker.setPosition(latlngset);

      google.maps.event.addListener(map, "click", function (event) {
        //Get the marker's location.
        vm.markerLocation(marker);
      });
    },

    getListClick() {
      var marker = 1;
      var vm = this;
      var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
      var options = {
        zoom: 4,
        center: centerOfMap,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
      };
      var map = new google.maps.Map(document.getElementById("myMap"), options);
      var latlngset = new google.maps.LatLng(this.lat, this.lon);

      marker = new google.maps.Marker({
        map: map,
        position: latlngset,
      });

      marker.setPosition(latlngset);

      google.maps.event.addListener(map, "click", function (event) {
        this.click = true;
        var clickedLocation = event.latLng;

        if (marker == 1) {
          marker = new google.maps.Marker({
            position: clickedLocation,
            map: map,
            draggable: true,
          });
          google.maps.event.addListener(marker, "dragend", function (event) {
            vm.markerLocation(marker);
          });
        } else {
          marker.setPosition(clickedLocation);
        }

        //Get the marker's location.
        vm.markerLocation(marker);
      });
    },
    markerLocation(marker) {
      var currentLocation = marker.getPosition();
      this.lat = currentLocation.lat(); //latitude
      this.lon = currentLocation.lng(); //longitude
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.image = URL.createObjectURL(this.file);
    },
    uploadImage() {
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("id", this.id1);
      formData.append("image", this.file);
      axios({
        method: "POST",
        url: "/user/imageupload",

        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })
        .then((response) => {
          this.resetForm();
          alert("User Details edited Successfully");
          this.$router.push({ path: "/Userlist" });
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.error = e.response.data.msg;
          alert("User Details edited Successfully");
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      var edit = {};
      edit["username"] = this.username;
      edit["name"] = this.name;
      edit["password"] = this.password;
      edit["phone"] = this.phone;
      edit["email"] = this.email;
      edit["occupation"] = this.occupation;
      edit["organization"] = this.organization;
      edit["gender"] = this.gender;
      edit["state"] = this.state;
      edit["lat"] = this.lat;
      edit["lon"] = this.lon;
      edit["id"] = this.id;
      edit["x-auth-token"] = localStorage.getItem("token");
      axios({
        method: "post",
        url: "/user/adminedit",
        data: edit,
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.id = response.data._id;
          this.loading = "false";
          if (response.data.status === true) {
            this.id1 = response.data.data._id;
            if (this.file) this.uploadImage();
          }
          if (response.data.status === false) {
            this.loading = false;

            alert("Please try again");
          }
        })
        .catch((err) => {
          this.loading = false;

          alert("Please try again");
        });
    },

    onsubmit1(evt) {
      this.visible = true;

      var data = {};

      data["password"] = this.password;
      data["id"] = this.id;
      data["x-auth-token"] = localStorage.getItem("token");

      evt.preventDefault();
      if (this.password === this.confPassword) {
        axios({
          method: "post",
          url: "/user/adminedit",
          data: data,
        })
          .then((response) => {
            this.visible = false;
            this.status = response.data.status;
            this.msg = response.data.msg;
            if (response.data.status === true) {
              alert("Password Changed Successfully");
              this.$bvModal.hide("modal-footer-sm");
              this.getDetails();
            } else {
              alert("Please Try Again");
            }
          })
          .catch((err) => {
            if (err.response.data.status === false) {
              this.msg = "Please Try Again";
            }
          });
      }
    },
  },
};
</script>

<style>
.card-body>>>table>tbody>tr>td {
  cursor: pointer;
}

.btn.btn-sm,
.btn-group-sm>.btn {
  display: none !important;
}

#myMap {
  height: 400px !important;
  width: 100%;
}
</style>